import React from 'react';
import { Table } from 'react-bootstrap';
import Head from "./components/Head";
import Row from "./components/Row";
import TotalRow from "./components/TotalRow";

const PropellerAdsReportTable = ({ params, paramsObj, report, total, onSortChange }) => {
    const rows = report.map((row, index) => (<Row params={params} paramsObj={paramsObj} row={row} key={index} />));

    return (
        <Table bordered responsive>
            <Head onSortChange={onSortChange} params={params} />
            <tbody>
                <TotalRow params={params} paramsObj={paramsObj} data={total}/>
                {rows}
            </tbody>
        </Table>
    )
};

export default PropellerAdsReportTable;



// WEBPACK FOOTER //
// ./src/scenes/PropellerAdsReport/components/Table/index.js